import { CONSUMERS_SEGMENT_PAGE } from "@/data/marketing/segmentPages";
import SegmentLandingPage from "./SegmentLandingPage";

const HelpGenieForConsumersPage = () => {
  return <SegmentLandingPage content={CONSUMERS_SEGMENT_PAGE} />;
};

export default HelpGenieForConsumersPage;
